<template>
  <el-cascader
    v-model="value"
    :options="options"
    :props="{
      value: 'Value',
      label: 'Text',
      children: 'Children',
      emitPath: false,
      ...propsOther,
    }"
    @change="change"
    :placeholder="placeholder"
    clearable
  ></el-cascader>
</template>

<script>
//选择部门id组件
export default {
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    value: String,
    propsOther: {
      type: Object,
      default() {
        return {
          checkStrictly: true,
        };
      },
    },
    placeholder: {
      type: String,
      default: "请选择",
    },
  },
  data() {
    return {
      options: [],
    };
  },
  mounted() {
    this.getTenantChildList();
  },
  methods: {
    getTenantChildList() {
      this.$http({
        url: "/api/common/GetDepartmentAndCustomer",
        method: "get",
      }).then((res) => {
        this.options = res.data.response;
      });
    },
    change(e) {
      this.$emit("change", e);
    },
  },
};
</script>

<style>
</style>